import type { SVGProps } from 'react';
const SvgIconEnvironment = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 1.5a6.48 6.48 0 0 1 4.816 2.136l.083-.01a5 5 0 0 1 1.265.024c.467.08 1.047.294 1.313.864.288.617.023 1.247-.254 1.677a5.5 5.5 0 0 1-.785.925q.061.434.062.884a6.5 6.5 0 0 1-11.317 4.364 5.5 5.5 0 0 1-1.212.006c-.476-.06-1.08-.241-1.39-.772l-.058-.112-.045-.107c-.195-.536.004-1.073.23-1.457.202-.344.499-.693.853-1.038A6.5 6.5 0 0 1 8 1.5m4.99 6.802c-1.048.746-2.364 1.507-3.828 2.19-1.465.683-2.894 1.201-4.14 1.525a5 5 0 0 0 7.968-3.715m-10.988 2.38a1 1 0 0 0-.077.15c.049.015.124.037.236.05l.013.002a7 7 0 0 1-.127-.272zM8 3a5 5 0 0 0-4.175 7.751c1.281-.248 2.944-.798 4.703-1.618s3.249-1.742 4.263-2.564A5 5 0 0 0 8 3m5.826 2.118q.066.134.127.273l.008-.012c.061-.095.093-.165.112-.212a1 1 0 0 0-.16-.038q-.042-.006-.087-.01"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconEnvironment;
